import { createClient } from '@slerp/client'
import gql from 'graphql-tag'
import compact from 'lodash/compact'
import { Option } from '../types'
import flatten from 'lodash/flatten'
type CustomRuleType = { getFieldValue: (arg: string) => string }
type GetVariantOptionsType = {
  data?: {
    variant_options: [
      {
        options: null | Option[]
      }
    ]
  }
  loading: boolean
  networkStatus: number
}

const GET_VARIANT_OPTIONS = gql`
  query getVariantOptions($productId: uuid!) {
    variant_options: product_variants(
      where: { product_id: { _eq: $productId } }
    ) {
      options
    }
  }
`

const normalizeResponse = (response: GetVariantOptionsType) => {
  const { variant_options } = response?.data || {}
  return variant_options
}

const getVariantOptions = async (productId: string) => {
  const apiKey = localStorage.getItem('token') || ''
  const client = createClient(apiKey)
  const variables = {
    productId
  }

  return await client
    .query({
      query: GET_VARIANT_OPTIONS,
      variables
    })
    .then((response) => normalizeResponse(response))
}

const required = { required: true, message: 'This is a required field.' }
const variantGroupNameValidator = (options: string[]) => {
  const uniqueVariantGroupName = () => ({
    validator(_: any, value: string) {
      return options.includes(value.trim())
        ? Promise.reject('Variant group name already exists.')
        : Promise.resolve()
    }
  })

  return [required, uniqueVariantGroupName]
}

const variantGroupOptionValidator = (
  productId: string,
  variantGroupName: string,
  activeVariantOptions: string[]
) => {
  const uniqueVariantOptionName = ({ getFieldValue }: CustomRuleType) => ({
    async validator(_: any, value: string) {
      const masterOptions = await getVariantOptions(productId)
      const variantGroupRelatedOptions = flatten(
        compact(
          // @ts-ignore
          masterOptions?.map(({ options }: Options[]) =>
            (options || []).find(
              ({ name }: Option) => name === variantGroupName
            )
          )
        ).map(({ values }: Option) => values)
      )

      const additionalRejectCopyText = activeVariantOptions.includes(
        value.toLowerCase()
      )
        ? ''
        : 'Please unarchive the variant to use it.'

      return variantGroupRelatedOptions.includes(value.toLowerCase())
        ? Promise.reject(
            `You have a variant with this name already. ${additionalRejectCopyText}`
          )
        : Promise.resolve()
    }
  })

  return [required, uniqueVariantOptionName]
}

const requiredRule = [required]
export { requiredRule, variantGroupNameValidator, variantGroupOptionValidator }
